// components/AppSplash.jsx
import { Spin } from 'antd';

export default function AppSplash() {
    return (
        <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f5f5f9' }}>
            <Spin size="large" tip="Chargement…" />
        </div>
    );
}
